import Layer from '@arcgis/core/layers/Layer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import cameraDefaultUrl from '@rsos/components/capstone/common/Map/assets/camera_default.svg';

/**
 * Creates a SimpleRenderer using the shared camera_default.svg icon as a
 * PictureMarkerSymbol, suitable for point FeatureLayers.
 */
export function createCameraRenderer() {
  return new SimpleRenderer({
    symbol: new PictureMarkerSymbol({
      url: cameraDefaultUrl,
      width: '24px',
      height: '24px',
    }),
  });
}

/**
 * If the layer title contains "camera" (case-insensitive), set opacity to 0.8.
 * For FeatureLayers, also apply the camera_default.svg point renderer.
 */
export function applyCameraRenderer(layer: Layer): void {
  if (!layer.title?.toLowerCase().includes('camera')) {
    return;
  }

  layer.opacity = 0.8;

  if (layer.type === 'feature') {
    (layer as __esri.FeatureLayer).renderer = createCameraRenderer();
  }
}
